import { Input, InputField } from '@components/form';
import { EmployeesFormLogin } from './EmployeesFormLogin';
import { ModalButton } from '@components/modalButton/ModalButton';
import Divider from 'material-ui/Divider';
import * as React from 'react';
import { required } from '@utils/validators';
import { Col, Grid, Row } from 'react-flexbox-grid';

const View: React.SFC<any> = ({ hasEntity }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={6} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Přihlašovací údaje</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                id="username"
                disabled={hasEntity}
                name="username"
                label="Uživatelské jméno *"
                validate={required}
              />
            </Col>
          </Row>
          <Row>
            {hasEntity ? (
              <Col md={6}>
                <ModalButton ModalComponent={EmployeesFormLogin} label="Změnit přihlasovací údaje" />
              </Col>
            ) : (
              <Col md={12}>
                <p>Pro změnu přihlasovacích údajú musí být zaměstnanec již vytvořen</p>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>

    <Grid fluid={true}>
      <Row>
        <Col md={12}>
          <Divider />
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);

export const EmployeesFormLogins = View;



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormLogins.tsx